/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const LicenseBundle = {
    None: 'None',
    Unicheck: 'Unicheck',
    Basic: 'Basic'
} as const;
export type LicenseBundle = typeof LicenseBundle[keyof typeof LicenseBundle];


export function LicenseBundleFromJSON(json: any): LicenseBundle {
    return LicenseBundleFromJSONTyped(json, false);
}

export function LicenseBundleFromJSONTyped(json: any, ignoreDiscriminator: boolean): LicenseBundle {
    return json as LicenseBundle;
}

export function LicenseBundleToJSON(value?: LicenseBundle | null): any {
    return value as any;
}

/**
 * Check if a given object implements the LicenseBundle interface.
 */
 export function instanceOfLicenseBundle(value: any): value is LicenseBundle {
    return Object.values(LicenseBundle).includes(value)
}

